import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Grid, Group, Paper, Stack, Text } from '@mantine/core';
import { IconCopy, IconSettings, IconTrash } from '@tabler/icons-react';

import { useGetProphetPages } from '../../api/getPages';
import { useGetProphetRules } from '../../api/getRules';
import { useRemoveRule } from '../../api/removeRule';
import { ChunkPlatform } from '../../utils/chunk-limits';
import { AddButton } from '../AddButton';

import { AddModal } from './AddModal';
import { EditModal } from './EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { useDepartmentStore } from '@/stores/department';
import { COLORS } from '@/utils/colors';

// `platform` comes from the route `:platform` param (via ProphetPage).
export const Rules = ({ pageId, platform }: { pageId: string; platform: ChunkPlatform }) => {
  const department = useDepartmentStore((state) => state.selected);

  const { data, isLoading } = useGetProphetRules({ pageId });
  const { data: prophetPages } = useGetProphetPages({ department, platform });

  const removeRule = useRemoveRule({ pageId });
  const rules = data?.rules || [];

  const appPageId = prophetPages?.pages.find((pp) => pp._id === pageId)?.appPage?._id ?? '';

  return (
    <>
      <Grid columns={5}>
        {rules.map((rule) => (
          <Grid.Col key={rule._id} span={1}>
            <Paper shadow="md" radius="md" p="md">
              <Group justify="space-between">
                <Stack gap="xs">
                  <Text size="sm">{rule.keyword || 'Стандартное правило'}</Text>
                </Stack>
                <Group gap="xs">
                  <ActionIcon
                    variant="filled"
                    onClick={() => NiceModal.show(EditModal, { appPageId, rule, platform })}
                    radius="md"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <IconSettings color={COLORS.text} />
                  </ActionIcon>
                  <ActionIcon
                    variant="filled"
                    onClick={() =>
                      NiceModal.show(AddModal, {
                        pageId,
                        appPageId,
                        rule,
                        platform,
                      })
                    }
                    radius="md"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <IconCopy color={COLORS.text} />
                  </ActionIcon>
                  {rule.keyword && (
                    <ActionIcon
                      variant="filled"
                      onClick={() =>
                        NiceModal.show(ConfirmModal, {
                          title: `Remove keyword rule (${rule.keyword})?`,
                          onSuccess: () => removeRule.mutate({ ruleId: rule._id }),
                        })
                      }
                      radius="md"
                      style={{ alignSelf: 'flex-start' }}
                    >
                      <IconTrash color={COLORS.red} />
                    </ActionIcon>
                  )}
                </Group>
              </Group>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
      <AddButton
        isLoading={isLoading}
        onClick={() => NiceModal.show(AddModal, { appPageId, pageId, platform })}
      />
    </>
  );
};
